import React from 'react'
import { actions, useDispatch } from '../../store'
import styles from './rotate-button.module.scss'

export const RotateButton: React.FC = () => {
  const dispatch = useDispatch()
  const rotate = () => dispatch(actions.addRotationClamp())
  return <div className={styles.button} onClick={rotate} />
}
